export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 18"
  height="18"
  width="18"
>
  <path
     d="M 3.226445,17.986481 0.01348804,14.757239 5.754389,9.0000159 0.01348804,3.2427919 3.226445,0.01353188 12.229233,9.0163189 Z"
  />
</svg>`;
